import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { convertToOption } from "src/utils/convertToOption";
import { errorResponsesTrns } from "src/translate/responses";
import { ICloneType } from "src/@types/cloneTypes";

export const CLONE_TYPES_SLICE_NAME = "cloneTypes";

export const getCloneTypesAsync = createAsyncThunk(
  `${CLONE_TYPES_SLICE_NAME}/fetchCloneTypes`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<ICloneType[]>("/clone-types/");

      //CHANGE - temp use convertToOption
      return convertToOption(data);
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.cloneTypes;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
